import React, { useEffect, useState } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import InputWithDropdown from "../Inputs/InputWithDropdown";
import Label from "../Misc/Label";
import InputWithHorizontalLabel from "../Inputs/InputWithHorizontalLabel";
import { addProjectDetails } from "../../redux/actions/uiActions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import axios from "axios";

import { addToken } from "../../redux/actions/web3Actions";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
}));

const ProjectRegistrationStepFour = ({
  changeFlag,
  onNextClick,
  setDisableButton,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [maxSupply, setMaxSupply] = useState();
  const [circulatingSupply, setCirculatingSupply] = useState();
  const [launchPrice, setLaunchPrice] = useState();
  const [age, setAge] = useState();

  const [preSalePrice, setPreSalePrice] = useState();
  // const [preSalePrice, setPreSalePrice] = useState(0);
  const [vesting, setVesting] = useState("");
  const [tgeRelease, setTgeRelease] = useState("");
  const web3context = useWeb3React();

  const projectData = useSelector((state) => state.ui.projectData);
  // console.log("addProject 44444444444==", projectData._id);
  const dispatch = useDispatch();
  const handleChange = (event) => {
    // console.log("opt ==========", event);
    setVesting(event);
  };
  const callbackFunction = (projId) => {
    if (projId) {
      axios
        .delete(`https://protokol-server.herokuapp.com/projects/${projId}`)
        .then(() => true);
    }
    history.push("/dashboard");

    console.log("HASAN CHALA");
  };
  useEffect(() => {
    if (
      maxSupply &&
      circulatingSupply &&
      launchPrice &&
      preSalePrice &&
      tgeRelease &&
      vesting
    )
      setDisableButton(false);
  }, [
    maxSupply,
    circulatingSupply,
    launchPrice,
    preSalePrice,
    tgeRelease,
    vesting,
    age,
  ]);
  // useEffect(() => {
  //   if (Object.keys(projectData).length > 0) {
  //     setMaxSupply(projectData.maxSupply || "");
  //     setCirculatingSupply(projectData.circulatingSupply || "");
  //     setLaunchPrice(projectData.launchPrice || "");
  //     setPreSalePrice(projectData.preSalePrice || "");
  //   }
  // }, []);

  useEffect(() => {
    if (changeFlag === 4) {
      console.log("flag clicked 4");
      // dispatch(
      //   addProjectDetails({
      //     maxSupply,
      //     circulatingSupply,
      //     launchPrice,
      //     preSalePrice,
      //     tgeRelease,
      //     vesting,
      //   })
      // );
      // dispatch(addProject({ ...projectData }));

      onNextClick();
      dispatch(
        addToken(
          web3context.account,
          projectData,
          {
            maxSupply,
            circulatingSupply,
            launchPrice,
            preSalePrice,
            tgeRelease,
            vesting: { duration: vesting, value: age },
            // budgetLeft: preSalePrice * circulatingSupply,
          },
          callbackFunction
        )
      );
    }
  }, [changeFlag]);

  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 4</Typography>

        <Typography className={classes.headingDesc}>
          Give the token details
        </Typography>
      </Box>

      <Box>
        <InputWithLabel
          label="Max Token Supply"
          placeholder="e.g. 10,000,000"
          type="number"
          value={maxSupply}
          setValue={setMaxSupply}
        />
        <InputWithLabel
          label="Initial Circulating Supply"
          placeholder="e.g. 1,000,000"
          type="number"
          value={circulatingSupply}
          setValue={setCirculatingSupply}
        />
        <InputWithLabel
          label="Token Launch Price (USDT)"
          placeholder="e.g. $0.01"
          type="number"
          value={launchPrice}
          setValue={setLaunchPrice}
        />
        <InputWithLabel
          label="Pre-Sale Token Price (USDT)"
          placeholder="e.g. $0.001"
          type="number"
          value={preSalePrice}
          setValue={setPreSalePrice}
        />

        <Box display="flex" alignItems="center">
          <Box marginRight="2rem">
            <Label label="Vesting" />
            <h1>{vesting}</h1>
            <InputWithDropdown
              options={["Weekly", "Monthly"]}
              label="Vesting"
              placeholder="e.g. 10"
              selectValue={vesting}
              // options={["Vesting 1", "Vesting 2"]}
              width={150}
              value={age}
              handleChange={handleChange}
              setValue={setAge}
            />
          </Box>

          <InputWithHorizontalLabel
            label="TGE Release"
            placeholder="i.e: 10"
            width={60}
            type="number"
            rightText="%"
            value={tgeRelease}
            setValue={setTgeRelease}
            maxValue1={100}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectRegistrationStepFour;
